<select #comboBox [(ngModel)]="selectedValue"
  [class.combo-box-required]="required"
  [disabled]="disabled" [hidden]="!visible" (change)="update($event);onChange($any($event.target).value);"
  (blur)="onTouched()"
  [style.width.px]="width" [style.width]="width !== undefined ? width : '100%'"
  [tabindex]="tabindex">
  <ng-template ngFor let-item [ngForOf]="model.cwsPlanCategoryList">
    <option value="{{item.CategoryCode}}">{{item.CategoryName}}</option>
  </ng-template>
</select>
